import Swal from 'sweetalert2';

export const Toast = Swal.mixin({
    toast: true,
    position: "bottom-start",
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: true,
});
